// extracted by mini-css-extract-plugin
export default {"main":"MainCarousel_main__O+oOB","mainIMG":"MainCarousel_mainIMG__Ynk7V","mainContent":"MainCarousel_mainContent__qOhLj","button":"MainCarousel_button__ca5RN"};